var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#329e51;}.cls-2{fill:#282828;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "375 0 375 80 0 80 0 0 62 0 79.01 8 295.99 8 313 0 375 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "375 5 375 85 0 85 0 5 62 5 79.01 13 295.99 13 313 5 375 5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbar);
export default __webpack_public_path__ + "static/media/navbar.9ac1a804f4098a862e85a3b1032b9045.svg";
export { ForwardRef as ReactComponent };